module.exports = __webpack_public_path__ + "img/icon-credit-card.bcc50d66.svg";